<div class="details-wrap" *ngIf="!loading && !error; else loadingOrError">
  <!-- Header -->
  <section class="header card">
    <div class="left">
      <h3>Order #{{ details?.publicOrderCode }}</h3>
      <div class="sub">
        <span class="chip">{{ details?.orderStatus | titlecase }}</span>
        <span class="dot" aria-hidden="true">•</span>
        <span class="chip alt">{{
          details?.orderType || "-" | titlecase
        }}</span>
      </div>
    </div>

    <div class="right total">
      {{
        details?.totalOrderModifiedPrice || 0
          | currency: "GBP" : "symbol" : "1.2-2"
      }}
    </div>
  </section>

  <section class="section card note-block" *ngIf="hasOrderComment">
    <h4 class="section-title">
      Customer note
      <button
        type="button"
        class="linkish copy-btn"
        (click)="copy(orderComment)"
      >
        Copy
      </button>
    </h4>
    <p class="note-text">{{ orderComment }}</p>
  </section>

  <!-- (Optional) Internal note -->
  <section class="section card note-block internal" *ngIf="hasTenantComment">
    <h4 class="section-title">
      Internal note
      <button
        type="button"
        class="linkish copy-btn"
        (click)="copy(tenantComment)"
      >
        Copy
      </button>
    </h4>
    <p class="note-text">{{ tenantComment }}</p>
  </section>

  <!-- Delivery -->
  <section class="section card" *ngIf="details?.orderType === 'delivery'">
    <h4 class="section-title">Delivery Address</h4>
    <address class="addr">
      {{ details?.delivery?.address_line_1
      }}<br *ngIf="details?.delivery?.address_line_2" />
      <span *ngIf="details?.delivery?.address_line_2">
        {{ details?.delivery?.address_line_2 }}<br />
      </span>
      {{ details?.delivery?.city }}, {{ details?.delivery?.county }}<br />
      {{ details?.delivery?.country }} {{ details?.delivery?.postal_code }}
    </address>
  </section>

  <!-- Items -->
  <section class="section card">
    <h4 class="section-title">
      Items -
      <span class="count-pill" *ngIf="totalItemsCount > 0">{{
        totalItemsCount
      }}</span>
    </h4>

    <ul class="items" *ngIf="(details?.details?.length || 0) > 0; else noItems">
      <li class="item-card" *ngFor="let it of details?.details || []">
        <div class="row">
          <div class="name">
            <span class="qty">{{ it.itemQuantity }} ×</span>
            <span [innerHTML]="it.itemName"></span>
          </div>
          <div class="price">
            {{ it.itemModifiedPrice | currency: "GBP" : "symbol" : "1.2-2" }}
          </div>
        </div>

        <!-- removed per request: individual item status + updated time -->

        <div class="extras" *ngIf="(it.extras?.length || 0) > 0">
          <div class="extras-title">Extras</div>
          <ul>
            <li *ngFor="let ex of it.extras">
              {{ ex.extraQuantity }} × {{ ex.extraName }}
              <span class="ex-price" *ngIf="ex.extraPrice">
                ({{ ex.extraPrice | currency: "GBP" : "symbol" : "1.2-2" }})
              </span>
            </li>
          </ul>
        </div>

        <div class="note" *ngIf="it.itemNote">
          <span class="note-label">Note:</span> {{ it.itemNote }}
        </div>
      </li>
    </ul>

    <ng-template #noItems>
      <div class="empty">No items found for this order.</div>
    </ng-template>
  </section>

  <!-- Footer CTAs (sticky) -->
  <section class="footer-ctas">
    <div class="cta-left">
      <button
        class="btn danger outline"
        *ngIf="showAcceptDecline"
        (click)="decline()"
        [disabled]="actionBusy"
      >
        Decline
      </button>

      <button
        class="btn danger"
        *ngIf="canRefund"
        (click)="onRefund()"
        [disabled]="actionBusy"
        title="Issue a full or partial refund"
      >
        Refund
      </button>

      <button
        type="button"
        class="btn outline"
        (click)="printReceipt()"
        [disabled]="!details"
      >
        Print receipt
      </button>
    </div>

    <div class="cta-right">
      <button
        class="btn primary"
        *ngIf="showAcceptDecline"
        (click)="acceptAndPrint()"
        [disabled]="actionBusy"
      >
        Accept
      </button>

      <button
        class="btn"
        *ngIf="showStartPrep"
        (click)="startPrep()"
        [disabled]="actionBusy"
      >
        Start Prep
      </button>

      <button
        class="btn"
        *ngIf="showSendDelivery"
        (click)="sendToDelivery()"
        [disabled]="actionBusy"
      >
        {{
          (details?.orderType || "delivery") === "collection"
            ? "Ready for collection"
            : "Send to Delivery"
        }}
      </button>

      <button
        class="btn success"
        *ngIf="showComplete"
        (click)="complete()"
        [disabled]="actionBusy"
      >
        Complete
      </button>
    </div>
  </section>
</div>

<ng-template #loadingOrError>
  <div *ngIf="loading" class="loading">
    <div class="sk-line w60"></div>
    <div class="sk-line w80"></div>
    <div class="sk-line w40"></div>
  </div>
  <div *ngIf="!loading && error" class="error">{{ error }}</div>
</ng-template>
